import PropTypes from 'prop-types';

const SharingIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39 3a9 9 0 0 1 9 9v24a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9V12a9 9 0 0 1 9-9h30zm0 3.9H9a5.1 5.1 0 0 0-5.092 4.82L3.9 12v24a5.1 5.1 0 0 0 4.82 5.092L9 41.1h30a5.1 5.1 0 0 0 5.092-4.82L44.1 36V12a5.1 5.1 0 0 0-4.82-5.092L39 6.9zm-13.592 7.9 6.231 5.714c.78.732.831 1.905.052 2.686a2.13 2.13 0 0 1-2.856.049l-2.804-2.589v11.185c0 1.026-.882 1.905-2.025 1.905-1.09 0-2.025-.83-2.025-1.905V20.66l-2.804 2.589c-.779.733-2.077.733-2.856-.049-.363-.39-.571-.83-.571-1.319 0-.488.208-.976.623-1.367l6.231-5.715a2.063 2.063 0 0 1 2.804 0z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

SharingIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

SharingIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default SharingIcon;
